import React from 'react';
import Layout from 'layout/Layout';
import ReservationQuestionnaireComponent from 'components/ReservationQuestionnaireComponent';

const ReservationQuestionnairePage: React.FC = () => {
  const pageTitle = '事前アンケート';

  return (
    <Layout pageTitle={pageTitle}>
      <ReservationQuestionnaireComponent />
    </Layout>
  );
};

export default ReservationQuestionnairePage;
